import React from "react";
import { Space, Tooltip } from "antd";
import { SvgIcon } from "../../../../common/components/SvgIcon";
import { GenericCard } from "../../../../common/components/GenericCard";
import styles from "./FinancialOverviewCard.module.less";

export interface FinancialOverviewCardProps {
    title: string;
    tip: string;
    data: number | string;
    dataColor?: string;
}

export const FinancialOverviewCard: React.FC<FinancialOverviewCardProps> = ({
    title,
    tip,
    data,
    dataColor,
}) => {
    return (
        <GenericCard radius="slightly" className={styles.main}>
            <Space size={4}>
                <span className={styles.title}>{title}</span>
                <Tooltip title={tip}>
                    <SvgIcon name="help" color="#1890FF" size={12} />
                </Tooltip>
            </Space>
            <div
                style={{
                    color: dataColor,
                }}
                className={styles.data}
            >
                {`$${data}`}
            </div>
        </GenericCard>
    );
};
